export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";